import useDynamicConfig from "./useDynamicConfig";
import DynamicConfigFglas from "../configs";

export default function useGetDynamicConfig(key: DynamicConfigFglas): unknown {
  return useDynamicConfig().get(key);
}
